<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="january-2000-eastbourne">
<p style="text-align:center"><img alt="" src="media/file1.png" style="width:3.60722in;height:2.96389in"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?433cd6a4